import { useUserRequest, RequestOptions, HttpMethod } from "../common/lib/fetch";
import { useUser } from "../userAccess/useUser";

const useUpdateBusinessHours = (options?: RequestOptions) => {
  const user = useUser();

  return useUserRequest({
    path: `/api/sites/${user.selectedSite!.id}/businessHoursSettings`,
    method: HttpMethod.POST
  }, options);
}

export default useUpdateBusinessHours;